import {Label} from '@/components/ui/label';
import {Input} from '@/components/ui/input';
import {Textarea} from '@/components/ui/textarea';
import {RewardFormData} from '../types';

interface FormStep1ContentProps {
    formData: RewardFormData;
    onChange: (data: Partial<RewardFormData>) => void;
    disabled: boolean;
}

export const FormStep1Content = ({formData, onChange, disabled}: FormStep1ContentProps) => {
    return (
        <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Conteúdo do Offerwall</h3>

            <div className="space-y-2">
                <Label>Tipo de Reward</Label>
                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={() => onChange({type: 'standard'})}
                        disabled={disabled}
                        className={`px-4 py-2 rounded-lg border text-sm font-medium transition-colors ${
                            formData.type !== 'quiz'
                                ? 'border-blue-500 bg-blue-50 text-blue-700'
                                : 'border-gray-200 text-gray-600 hover:bg-gray-50'
                        }`}
                    >
                        Standard
                    </button>
                    <button
                        type="button"
                        onClick={() => onChange({type: 'quiz'})}
                        disabled={disabled}
                        className={`px-4 py-2 rounded-lg border text-sm font-medium transition-colors ${
                            formData.type === 'quiz'
                                ? 'border-purple-500 bg-purple-50 text-purple-700'
                                : 'border-gray-200 text-gray-600 hover:bg-gray-50'
                        }`}
                    >
                        Quiz
                    </button>
                </div>
                <p className="text-xs text-gray-500">
                    {formData.type === 'quiz'
                        ? 'Quiz com perguntas configuráveis e loaders entre elas'
                        : 'Offerwall padrão com título, descrição e botão'}
                </p>
            </div>

            {formData.type === 'quiz' && (
                <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mt-2">
                    <p className="text-sm font-medium text-purple-800">Tela Final do Quiz</p>
                    <p className="text-xs text-purple-600 mt-1">
                        Estes campos configuram a última tela exibida após o usuário completar todas as perguntas.
                    </p>
                </div>
            )}

            <div className="space-y-2">
                <Label htmlFor="title">
                    {formData.type === 'quiz' ? 'Título da Tela Final *' : 'Título *'}
                </Label>
                <Input
                    id="title"
                    value={formData.title}
                    onChange={(e) => onChange({title: e.target.value})}
                    placeholder={formData.type === 'quiz'
                        ? 'Ex: Queres saber como conseguir Robux?'
                        : 'Ex: Ganhe 10% de desconto!'}
                    disabled={disabled}
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="description">
                    {formData.type === 'quiz' ? 'Descrição da Tela Final (opcional)' : 'Descrição *'}
                </Label>
                <Textarea
                    id="description"
                    value={formData.description}
                    onChange={(e) => onChange({description: e.target.value})}
                    placeholder={formData.type === 'quiz'
                        ? 'Ex: Ver recomendação patrocinada pra continuar'
                        : 'Ex: Complete esta oferta e receba um cupom exclusivo'}
                    rows={formData.type === 'quiz' ? 2 : 4}
                    disabled={disabled}
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="button_text">
                    {formData.type === 'quiz' ? 'Texto do Botão Final *' : 'Texto do Botão *'}
                </Label>
                <Input
                    id="button_text"
                    value={formData.button_text}
                    onChange={(e) => onChange({button_text: e.target.value})}
                    placeholder={formData.type === 'quiz'
                        ? 'Ex: Si! Quiero saberlo ahora'
                        : 'Ex: Resgatar Agora'}
                    disabled={disabled}
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="link">Link de Redirecionamento</Label>
                <Input
                    id="link"
                    type="url"
                    value={formData.link}
                    onChange={(e) => onChange({link: e.target.value || ''})}
                    placeholder="https://exemplo.com/oferta"
                    disabled={disabled}
                />
            </div>
        </div>
    );
};